'use strict';

import Swiper from "swiper";

const Anchors = {
    el: null,
    swiper: null,
    sections: [],
    links: [],
    init: function () {
        Anchors.el = document.querySelector('.c-anchors');
        if (Anchors.el) {
            const sliderEl = Anchors.el.querySelector(".swiper");
            if (!sliderEl) {
                console.error("Swiper container (.swiper) not found in:", Anchors.el);
                return;
            }
            Anchors.swiper = new Swiper(sliderEl, {
                navigation: false,
                pagination: false,
                slidesPerView: 'auto',
                watchOverflow: true,
                freeMode: true,
                loop: false,
                spaceBetween: 0,
                mousewheel: {
                    forceToAxis: true
                }
            });

            Anchors.links = Array.from(Anchors.el.querySelectorAll('a'));
            if (Anchors.links && Anchors.links.length > 0) {
                Anchors.sections = Anchors.links.map(link => document.querySelector(link.getAttribute('href')));

                window.addEventListener('scroll', Anchors.handleScroll);
                Anchors.handleScroll(); // Initial check

                Anchors.links.forEach(link => {
                    link.addEventListener('click', (e) => {
                        e.preventDefault();
                        const sectionToShow = document.querySelector(link.getAttribute('href'));
                        if (sectionToShow) {
                            // sectionToShow.scrollIntoView({behavior: "smooth", block: "center"});
                            const headerHeight = document.querySelector('.c-header') ? document.querySelector('.c-header').offsetHeight : 82;
                            const anchorsHeight = document.querySelector('.c-anchors') ? document.querySelector('.c-anchors').offsetHeight : 80;
                            const offset = headerHeight + anchorsHeight;
                            const top = sectionToShow.getBoundingClientRect().top + window.scrollY - offset - 20;
                            window.scrollTo({ top, behavior: "smooth" });
                        }
                    });
                })
            }
        }
    },
    handleScroll: function () {
        const scrollPosition = window.scrollY + window.innerHeight / 2;

        Anchors.sections.forEach((section, index) => {
            if(section){
                if (section.offsetTop <= scrollPosition && section.offsetTop + section.offsetHeight > scrollPosition) {
                    Anchors.links.forEach(link => link.classList.remove('active'));
                    Anchors.links[index].classList.add('active');
                    Anchors.swiper.slideTo(index);
                }
            }
        });
    }
}

export default Anchors;